import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

// Maps boolean filter in the given direction
// out --> "Yes" / "No" to true / false
// in --> true / false "Yes" / "No"
export const mapBooleanFilter = (value: any[], direction: 'in' | 'out') => {
  if (isNilOrEmpty(value)) {
    return [];
  }

  if (direction === 'out') {
    return value.map(item => {
      return item === 'Yes';
    });
  }

  return value.map(item => {
    return item === true ? 'Yes' : 'No';
  });
};
